import { render, staticRenderFns } from "./DailyHealthVerification.vue?vue&type=template&id=332bf285&scoped=true&"
import script from "./DailyHealthVerification.vue?vue&type=script&lang=js&"
export * from "./DailyHealthVerification.vue?vue&type=script&lang=js&"
import style0 from "./DailyHealthVerification.scss?vue&type=style&index=0&id=332bf285&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332bf285",
  null
  
)

export default component.exports